import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Controller, useForm } from 'react-hook-form';
import {
  Box,
  FormControl,
  Grid,
  InputAdornment,
  Tab,
  Tabs,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';

import SectionContainer from '../../../Components/SectionContainer';
import PageHeading from '../../../Components/PageHaeding';

import InputField from '../../../Components/Input';
import AutocompleteSelect from '../../../Components/AutocompleteSelect';
import CustomButton from '../../../Components/CustomButton';

import {
  getPermissionRoles,
  getPermissionRolesbyIdS,
} from '../../../redux/episodeSlice';
import { RootState, useAppSelector } from '../../../redux/store';
import {
  debouncedEmailCheck,
  getDepartmentListForAddContact,
  getRoleList,
} from '../../../redux/commonSlice';
import { getMemberDetails, UpdateMember } from '../../../redux/locationSlice';
import { getUserDetailsWithPhone } from '../../../redux/StudioSlice';

import { COUNTRY_LIST } from '../../../assets/json/country_dial_info';
import { addContactProductionSchema } from '../../../Utils/yupvalidations';

// import CustomTabPanel from '../../../Components/CustomTabPanel'
import ProductionRoles from './ProductionRoles';
import { updateContactsList } from '../../../redux/ProductionSlice';
import BreadcrumNested from '../../../Components/BreadcrumNested';
import NoData from '../../../Components/Nodata';
import { notify } from '../../../Utils/toastify';
import SelectPhoneNumber from '../../../Components/SelectPhoneNumber';

import Loading from '../../../Components/Loading';
import WarningDialog from '../../../Components/WarningDialog';
import MUIAutoComplete from '../../../Components/EditMUIAutoComplete';
import AddJobTitleModal from '../../../Components/AddJobTitleModal';

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 2, px: 0, pb: 0 }}>
          <div className="tabContainer">{children}</div>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const AddContactsProducts = ({ departmentId }: { departmentId: string }) => {
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const [isDisabled, setIsDisabled] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);
  const [keyName, setKeyName] = useState<any>([]);
  const [checkEmailStatus, setCheckEmailStatus] = useState(false);

  const deptList = useAppSelector(
    (state: RootState) => state.common.departmentAddContact,
  );

  const {
    productionFormData: { clients },
    contacts,
  } = useSelector((state: any) => state.production);
  const { getrole } = useAppSelector((state: RootState) => state.episode);
  const { memberdetails } = useAppSelector(
    (state: RootState) => state.location,
  );

  const { loading } = useSelector((state: any) => state.location);
  const [isContactState, setIsContactState] = useState(
    () => memberdetails?.isContact && !memberdetails?.isCrew,
  );

  console.log(
    '=>>>',
    memberdetails,
    memberdetails?.isContact || memberdetails?.userType === 'CONTACT',
  );

  useEffect(() => {
    setIsContactState(memberdetails?.isContact && !memberdetails?.isCrew);
  }, [memberdetails]);
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    trigger,
    watch,
  } = useForm({
    resolver: yupResolver(addContactProductionSchema),
    mode: 'all',
    defaultValues: {
      countryCode: {
        name: 'United States',
        flag: '🇺🇸',
        code: 'US',
        dial_code: '+1',
      },
    },
  });

  useEffect(() => {
    getPermissionRoles();
    getDepartmentListForAddContact();
    // getPermissionRolesbyIdS()
  }, []);

  const [jobTitleList, setJobTitleList] = useState<any>([]);
  const [isJobTitleModalOpen, setIsJobTitleModalOpen] = useState(false);
  const [isCrewOpen, setIsCrewOpen] = useState(false);

  const selectedDepartment = watch('departmentId')?._id || departmentId;

  useEffect(() => {
    if (selectedDepartment) {
      getRoleList(selectedDepartment);
    } else setJobTitleList([]);
  }, [selectedDepartment]);

  const { roleList } = useAppSelector((state: RootState) => state.common);

  const fetchJobTitles = async () => {
    try {
      const data = roleList;
      setJobTitleList(
        data.filter(
          (item, index, self) =>
            index === self.findIndex(other => other._id === item._id),
        ),
      );
    } catch (error) {
      console.error('Error fetching job titles:', error);
    }
  };

  const location = useLocation();
  // console.log(location, 'location')
  const {
    isEdit,
    _id,
    productionId,
    isEditCrew,
    isCrew,
    isOnlyCrew,
    departMent,
    hideContactCheckbox,
    title,
  } = location.state || {};

  useEffect(() => {
    if (isEdit || isEditCrew) {
      getMemberDetails(_id);
    }
  }, []);
  // console.log(memberdetails?.departmentId, 'member')
  useEffect(() => {
    if (departMent) {
      setValue('departmentId', departMent);
    }
  }, [departMent]);
  useEffect(() => {
    if (memberdetails && (isEdit || isEditCrew)) {
      setValue('firstName', memberdetails.firstName);
      setValue('lastName', memberdetails.lastName);
      setValue('phoneNo', memberdetails.phone);
      setValue('email', memberdetails.email);
      // setValue('roleName', memberdetails.roleName || '');
      setValue('orderLimit', memberdetails.orderLimit);

      const country = COUNTRY_LIST.find(
        c => c.code === memberdetails.countryAbbreviation,
      );

      // Prefill countryCode with flag
      setValue('countryCode', {
        name: country ? country.name : '',
        flag: country ? country.flag : '',
        code: country ? country.code : '',
        dial_code: country ? country.dial_code : '',
      });

      // Get department name from deptList list using departmentId
      if (memberdetails.departmentId) {
        const department = deptList?.find(
          dept => dept._id === memberdetails.departmentId,
        );

        setValue('departmentId', {
          _id: memberdetails.departmentId,
          deptName: department ? department.deptName : '', // Use found name or empty string
        });
      }

      if (memberdetails?.roleName) {
        setValue('roleName', {
          _id: memberdetails?.roleId,
          roleName: memberdetails?.roleName,
          departmentId: memberdetails?.departmentId,
        });
      }

      if (memberdetails.staticRoleId) {
        setValue('staticRoleId', {
          value: memberdetails.staticRoleId,
          label: memberdetails.baseRole,
        });
        setValue('baseRole', memberdetails.baseRole);

        // Get permission roles by ID and then set permissions
        getPermissionRolesbyIdS(
          memberdetails.staticRoleId,
          (defaultData: any) => {
            const mergedPermissions = {
              productionPermissions: {
                ...defaultData.productionPermissions,
                ...memberdetails.productionPermissions,
              },
              episodePermissions: {
                ...defaultData.episodePermissions,
                ...memberdetails.episodePermissions,
              },
              setPermissions: {
                ...defaultData.setPermissions,
                ...memberdetails.setPermissions,
              },
              locationPermissions: {
                ...defaultData.locationPermissions,
                ...memberdetails.locationPermissions,
              },
              financeVisibilty: memberdetails.financeVisibility || [],
              // orderApprovals: memberdetails.orderApprovals || [],
              documentVisibilty: memberdetails.documentVisibility || [],
              chatAccess: memberdetails.chatAccess || false,
            };

            console.log('mergedPermissions =>>>', mergedPermissions);

            setAllRoles(mergedPermissions);

            // Set keyNames for tabs
            const tabNames = [
              'productionPermissions',
              'episodePermissions',
              'setPermissions',
              'locationPermissions',
            ];
            const names = tabNames.map(tab => {
              const permissions = mergedPermissions[tab];
              return Object.keys(permissions).find(
                key =>
                  key !== 'otherPermissions' && key !== 'permissionVisibility',
              );
            });
            console.log('name =>>>', names, tabNames);

            setKeyName(names);
          },
        );
      }

      // Set roleName with roleId for Job Title field - must match the structure of options
      // if (memberdetails.roleName && memberdetails.roleId) {
      //   setValue('roleName', {
      //     roleName: memberdetails.roleName,
      //     _id: memberdetails.roleId,
      //   });
      //   console.log('Setting roleName field:', {
      //     roleName: memberdetails.roleName,
      //     _id: memberdetails.roleId,
      //   });
      // } else {
      //   setValue('roleName', null);
      // }

      setIsDisabled(true);
    }
  }, [memberdetails, isEdit, isEditCrew, deptList, setValue]); // Added deptList to dependencies

  console.log(getValues(), 'roleName');

  const options = getrole.map(role => ({
    label: role.roleName, // The role name will be displayed in the autocomplete dropdown
    value: role._id, // The role ID will be used as the value
  }));

  const [valueTab, setValueTab] = React.useState(0);
  const [warningOpen, setWarningOpen] = useState(false);
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setValueTab(newValue);
  };
  const [allRoles, setAllRoles] = useState<any>({});
  const handleOpenWarning = () => {
    setWarningOpen(true);
  };
  // console.log(options, 'heya')

  // console.log('getrolebyid', getrolebyid)
  // console.log(allRoles, 'All Roles')
  const debounce = (func: Function, delay: number) => {
    let timer: NodeJS.Timeout | null = null;
    return (...args: any[]) => {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const debouncedFetchUserDetails = debounce(
    (phoneNo: any, countryCode: any) => {
      // console.log('Fetching user details...', phoneNo, countryCode)

      dispatch(
        getUserDetailsWithPhone(
          {
            phoneNo: phoneNo,
            countryCode: countryCode?.dial_code,
            countryAbbreviation: countryCode?.code,
          },
          (data: any) => {
            if (
              data?.message ===
              "User doesn't exist. Please enter an existing mobile number."
            ) {
              setValue(`firstName`, '');
              setValue(`lastName`, '');
              setValue(`email`, '');
              setValue(`countryAbbreviation`, countryCode?.code);
              setValue(`countryCode`, countryCode);
              setValue(`country`, countryCode?.name);
              setValue(`profilePicture`, '');

              setIsDisabled(false);
              return;
            }

            if (data) {
              setValue(`firstName`, data.data.firstName || '');
              setValue(`lastName`, data.data.lastName || '');
              setValue(`phoneNo`, data.data.phoneNo || '');
              setValue(`email`, data.data.email || '');
              setValue(`countryAbbreviation`, countryCode?.code);
              setValue(`countryCode`, countryCode);
              setValue(`country`, countryCode?.name);
              setValue(`profilePicture`, data.data.profilePicture || '');
              setIsDisabled(true);

              trigger('firstName');
              trigger('lastName');
              trigger('email');
            }
          },
        ),
      );
    },
    500,
  );

  // console.log('clients', clients)

  const handleNameChange = (index: number, name: string, e: any) => {
    const phoneNo: any = getValues('phoneNo');
    const countryCode: any = getValues('countryCode');

    if ((name === 'phoneNo' || name === 'countryCode') && phoneNo?.length > 4) {
      debouncedFetchUserDetails(phoneNo, countryCode); // ✅ Use the debounced function
    }
  };

  const handleBackSpace = (e: any, index: number, status?: boolean) => {
    if (
      (e.key === 'Backspace' ||
        e.key === 'Delete' ||
        (e.ctrlKey && e.key === 'x')) &&
      status
    ) {
      // console.log('yes herer')
      setValue(`firstName`, '');
      setValue(`lastName`, '');
      setValue(`email`, '');
      // fields[index].isDisabled = false
      setIsDisabled(false);
    }
  };

  useEffect(() => {
    const inputType: any = document.querySelector('#client_input_phone');

    // console.log('input =>>', inputType)

    if (inputType) {
      inputType.addEventListener('keypress', (evt: any) => {
        if (evt.which === 8) {
          return;
        }
        if (evt.which < 48 || evt.which > 57) {
          evt.preventDefault();
        }
      });
    }

    inputType.addEventListener('keydown', function (e: any) {
      if (e.which === 38 || e.which === 40) {
        e.preventDefault();
      }
    });
  }, []);

  const handleKeyDown = (event: any) => {
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      // console.log('yes in on Key down')
      event.preventDefault();
      return;
    }
  };

  const tabs = [
    'productionPermissions',
    'episodePermissions',
    'setPermissions',
    'locationPermissions',
  ];

  // const handleChangeCall = (
  //   status: boolean,
  //   label: string,
  //   name: any,
  //   key: any,
  //   type?: any,
  // ) => {
  //   // console.log(status, label, name, key, type)

  //   if (type) {
  //     setAllRoles({
  //       ...allRoles,
  //       [label]: {
  //         ...allRoles[label],
  //         [type]: {
  //           ...allRoles[label][type],
  //           [name]: {
  //             ...allRoles[label][type][name],
  //             [key]: status,
  //           },
  //         },
  //       },
  //     });
  //   } else {
  //     setAllRoles({
  //       ...allRoles,
  //       [label]: {
  //         ...allRoles[label],
  //         [name]: {
  //           ...allRoles[label][name],
  //           [key]: status,
  //         },
  //       },
  //     });
  //   }
  // };

  const handleChangeCall = (
    status: boolean,
    label: string,
    name: any,
    key: any,
    type?: any,
  ) => {
    setAllRoles((prev: any) => {
      if (type !== 'otherPermissions') {
        return {
          ...prev,
          [label]: {
            ...prev[label],
            [name]: {
              ...prev[label][name],
              [key]: status,
            },
          },
        };
      }

      const isRiskCenter =
        name?.toLowerCase() === 'riskcenter' ||
        name?.toLowerCase() === 'risk center';

      if (!isRiskCenter) {
        return {
          ...prev,
          [label]: {
            ...prev[label],
            otherPermissions: {
              ...prev[label].otherPermissions,
              [name]: {
                ...prev[label].otherPermissions[name],
                [key]: status,
              },
            },
          },
        };
      }

      const current = prev[label].otherPermissions[name];

      // ⭐ RULE 1: Uncheck VIEW → both false
      if (key === 'view' && !status) {
        return {
          ...prev,
          [label]: {
            ...prev[label],
            otherPermissions: {
              ...prev[label].otherPermissions,
              [name]: {
                ...current,
                view: false,
                edit: false,
              },
            },
          },
        };
      }

      // ⭐ RULE 2: Check EDIT → auto-check VIEW
      if (key === 'edit' && status) {
        return {
          ...prev,
          [label]: {
            ...prev[label],
            otherPermissions: {
              ...prev[label].otherPermissions,
              [name]: {
                ...current,
                view: true,
                edit: true,
              },
            },
          },
        };
      }

      // Normal toggle
      return {
        ...prev,
        [label]: {
          ...prev[label],
          otherPermissions: {
            ...prev[label].otherPermissions,
            [name]: {
              ...current,
              [key]: status,
            },
          },
        },
      };
    });
  };

  // Handle change to add/remove items from the array
  const handleChangeVisiblity = (
    checked: boolean,
    item: string,
    key: string,
  ) => {
    if (key === 'chatAccess') {
      setAllRoles((prev: any) => {
        const updatedArray = checked
          ? { ...prev, [key]: true } // Add the item if checked
          : { ...prev, [key]: false }; // Remove the item if unchecked

        return updatedArray;
      });
    } else {
      setAllRoles((prev: any) => {
        const updatedArray = checked
          ? [...prev[key], item] // Add the item if checked
          : prev[key].filter((i: string) => i !== item); // Remove the item if unchecked

        return { ...prev, [key]: updatedArray };
      });
    }
  };

  const [isSubmitting, setIsSubmitting] = useState(false);
  const { profileData } = useAppSelector((state: RootState) => state.common);
  // console.log(productionId, 'what is productionId', contacts)
  const onSubmit = async (data: any) => {
    if (isSubmitting) return; // Prevent multiple submissions

    setIsSubmitting(true); // Disable submit button

    console.log('Form data on submit:', data);
    console.log('roleName value:', data.roleName);

    const {
      firstName,
      lastName,
      phoneNo,
      email,
      profilePicture,
      countryCode: { dial_code, name, code },
      roleName,
      orderLimit,
      departmentId,
      staticRoleId,
      baseRole,
    } = data;

    const formattedRoleName = {
      _id: roleName?._id || roleName?.value?._id || roleName?.value,
      roleName:
        roleName?.roleName ||
        roleName?.value?.roleName ||
        roleName?.label ||
        roleName,
      departmentId: roleName?.departmentId || roleName?.value?.departmentId,
    };

    // Extract roleId from roleName object if it exists
    const extractedRoleId =
      typeof roleName === 'object' && roleName?._id ? roleName._id : undefined;
    const extractedRoleName =
      typeof roleName === 'string' ? roleName : roleName?.roleName;

    console.log('Extracted roleId:', extractedRoleId);
    console.log('Extracted roleName:', extractedRoleName);

    // Utility function to check for duplicate contact
    const isDuplicateContact = (contacts: any[], key: string, value: any) =>
      contacts?.some(contact => contact?.[key] === value);

    // Only check for duplicates if not editing
    if (!isEdit || !isEditCrew) {
      if (
        isDuplicateContact(contacts, 'phoneNo', phoneNo) &&
        isDuplicateContact(contacts, 'countryCode', dial_code)
      ) {
        setIsSubmitting(false);
        return notify('This number is already added in contacts', 'error');
      }

      if (isDuplicateContact(contacts, 'email', email)) {
        setIsSubmitting(false);
        return notify('This email is already added in contacts', 'error');
      }

      if (checkEmailStatus) {
        setIsSubmitting(false);
        return notify(
          'This email is already in use. Please use a different email.',
          'error',
        );
      }
    }

    const selectedRoleId = roleList.find((role: any) => {
      if (role.roleName === roleName) {
        return role._id;
      }
    });

    console.log('selectedRoleId', selectedRoleId);
    if (data?.phoneNo == profileData?.phoneNo) {
      setIsSubmitting(false);
      return notify('Unable to designate the owner as a contact', 'error');
    }
    const contactDataEdit = {
      modelEntityType: 'productions',
      modelEntityId: productionId,
      // orderLimit,
      staticRoleId: staticRoleId?.value,
      productionPermissions: allRoles?.productionPermissions,
      episodePermissions: allRoles?.episodePermissions,
      setPermissions: allRoles?.setPermissions,
      locationPermissions: allRoles?.locationPermissions,
      financeVisibility: allRoles?.financeVisibilty,
      // orderApprovals: allRoles?.orderApprovals,
      documentVisibility: allRoles?.documentVisibilty,
      memberType: isEdit ? 'CONTACT' : 'CREW_MEMBER',
      entityType: 'productions',
      roleName: formattedRoleName?.roleName || '',
      entityId: productionId,
      isContact: isContactState,
      roleId: selectedRoleId?._id,
      //  baseRole,
      departmentId: formattedRoleName?.departmentId || departmentId?._id || '',
      // departmentName: data?.departmentId?.deptName,
      ...(orderLimit !== undefined &&
        orderLimit !== '' &&
        orderLimit !== null && { orderLimit }), // Only include if orderLimit is valid
    };

    console.log('contactDataEdit payload:', contactDataEdit);

    try {
      if ((isEdit || isEditCrew) && _id) {
        await new Promise((resolve, reject) => {
          UpdateMember(
            _id,
            contactDataEdit,
            (response: any) => {
              setIsSubmitting(false);
              navigate(-1);
              if (response.error) {
                reject(response.error);
              } else {
                // setIsSubmitting(false)
                notify('Contact updated successfully', 'success');
                navigate(-1);
                resolve(response);
              }
            },
            () => {
              setIsSubmitting(false);
            },
          );
        });
      } else {
        const isDuplicate: any = clients?.some(
          (client: any) =>
            client.phoneNo === data?.phoneNo &&
            client.countryCode?.dial_code === data?.countryCode?.dial_code &&
            client.countryCode?.code === data?.countryCode?.code &&
            client?.countryCode?.name === data?.countryCode?.name,
        );

        if (isDuplicate) {
          notify(
            'The entered phone number is already associated with clients',
            'error',
          );
          // setValue(`phoneNo`, '')
          return;
        }

        const contactData = {
          firstName,
          lastName,
          phoneNo,
          email,
          country: name,
          countryCode: dial_code,
          countryAbbreviation: code,

          roleName,
          orderLimit,
          departmentId: departmentId?._id,
          // departmentName: data?.departmentId?.deptName,
          staticRoleId: staticRoleId?.value,
          productionPermissions: allRoles?.productionPermissions,
          episodePermissions: allRoles?.episodePermissions,
          setPermissions: allRoles?.setPermissions,
          locationPermissions: allRoles?.locationPermissions,
          financeVisibility: allRoles?.financeVisibilty,
          // orderApprovals: allRoles?.orderApprovals,
          documentVisibility: allRoles?.documentVisibilty,
          baseRole,
          roleId: extractedRoleId,
          ...(profilePicture && { profilePicture }),
        };

        updateContactsList(contactData);
        setIsSubmitting(false);
        notify('Contact added successfully', 'success');
        navigate(-1);
      }
    } catch {
      notify('Error saving contact. Please try again.', 'error');
      setIsSubmitting(false);
    } finally {
      setIsSubmitting(false); // Re-enable submit button
    }
  };
  useEffect(() => {
    setIsSubmitting(false);
  }, []);

  return (
    <>
      <div className="pageBody ">
        <PageHeading
          navigateUrl={-1}
          pageTitle={
            isEdit
              ? title
              : isCrew || isOnlyCrew
              ? 'Add Crew Member'
              : 'Add Contact Member'
          }
          pageName={
            isEdit
              ? title
              : isCrew || isOnlyCrew
              ? 'Add Crew Member'
              : 'Add Contact'
          }
          isNestedBreadcrum
          breadcrumNested={
            <BreadcrumNested
              breadcrums={
                isCrew
                  ? [
                      { name: 'Manage Crew Member', url: -1 },
                      { name: 'Edit Crew Member', url: '' },
                    ]
                  : isEdit
                  ? [
                      { name: 'Manage Contact', url: -1 },
                      { name: 'Edit Contact', url: '' },
                    ]
                  : null
              }
            />
          }
        />

        {loading ? (
          <Loading type="div" height="full" />
        ) : (
          <div className="lg-inputs">
            <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
              <SectionContainer
                heading="Role Details"
                children={
                  <div className="formContainer">
                    <Grid container spacing={2}>
                      <Grid item md={4} xs={12}>
                        {' '}
                        <InputField
                          id={'client_input_phone'}
                          label={'Mobile Number'}
                          name={`phoneNo`}
                          placeholder="Enter Mobile number"
                          type="number"
                          control={control}
                          disabled={isEdit || isEditCrew}
                          phone
                          maxLength={14}
                          requiredField
                          error={!!errors['phoneNo']}
                          getOnChangeValues={(e: any) => {
                            handleNameChange(0, 'phoneNo', e);
                          }}
                          // onBlurMethod={(e: any) => {
                          //   handleNameChange(0, 'countryCode', e)
                          // }}
                          helperText={
                            !!errors['phoneNo']
                              ? errors['phoneNo']?.message
                              : ''
                          }
                          onKeyUp={(e: any) =>
                            handleBackSpace(e, 0, isDisabled)
                          }
                          onKeyDown={handleKeyDown}
                          startAdornment={
                            <div className="select_in_field">
                              <FormControl fullWidth className="customSelect">
                                <Controller
                                  // label={'Mobile Number'}
                                  name={`countryCode`}
                                  control={control}
                                  defaultValue={'+1'}
                                  render={({ field }) =>
                                    field && (
                                      // <Select
                                      //   size="small"
                                      //   {...field}
                                      //   value={field.value}
                                      //   onChange={(e) => {
                                      //     field.onChange(e)
                                      //     handleNameChange(0, 'countryCode', e)
                                      //   }}
                                      //   // disabled={disabled}
                                      //   MenuProps={{
                                      //     PaperProps: {
                                      //       style: {
                                      //         maxHeight: '320px',
                                      //       },
                                      //     },
                                      //   }}
                                      // >
                                      //   {COUNTRY_LIST?.map((item: any) => {
                                      //     return (
                                      //       <MenuItem value={item?.dial_code}>
                                      //         {item.flag} {item?.dial_code}
                                      //       </MenuItem>
                                      //     )
                                      //   })}
                                      // </Select>
                                      <SelectPhoneNumber
                                        control={control}
                                        name="countryCode"
                                        labelText=""
                                        id={'countryCode'}
                                        disabled={isEdit || isEditCrew}
                                        keyName="dial_code"
                                        options={COUNTRY_LIST}
                                        setValue={setValue}
                                        clearIcon
                                        limit={10}
                                        onChangeMethod={(e: any) =>
                                          handleNameChange(0, 'countryCode', e)
                                        }
                                      />
                                    )
                                  }
                                />
                              </FormControl>
                            </div>
                          }

                          // requiredField
                        />
                      </Grid>
                      <Grid item md={4} xs={12}>
                        {' '}
                        <InputField
                          id={`attribute`}
                          label={'First Name'}
                          name={`firstName`}
                          placeholder="Enter first name"
                          type="text"
                          control={control}
                          getOnChangeValues={(e: any) =>
                            handleNameChange(0, 'firstName', e)
                          }
                          error={!!errors['firstName'] && !!errors['firstName']}
                          helperText={
                            !!errors['firstName']
                              ? errors['firstName']?.message
                              : ''
                          }
                          disabled={isDisabled}
                          requiredField
                          // requiredField={watch(`phoneNo`) ? true : false}
                        />
                      </Grid>
                      <Grid item md={4} xs={12}>
                        {' '}
                        <InputField
                          id={`attribute`}
                          label={'Last Name'}
                          name={`lastName`}
                          placeholder="Enter last name"
                          type="text"
                          control={control}
                          getOnChangeValues={(e: any) =>
                            handleNameChange(0, 'lastName', e)
                          }
                          error={!!errors['lastName'] && !!errors['lastName']}
                          helperText={
                            !!errors['lastName']
                              ? errors['lastName']?.message
                              : ''
                          }
                          disabled={isDisabled}
                          requiredField
                        />
                      </Grid>
                      <Grid item md={4} xs={12}>
                        {' '}
                        <InputField
                          id="attribute"
                          label="Email Address"
                          name="email"
                          placeholder="Enter email"
                          type="text"
                          control={control}
                          error={!!errors['email']}
                          getOnChangeValues={(e: any) => {
                            const email = e.target.value;
                            const emailRegex =
                              /^[\w-]+(?:\.[\w-]+)*@((?:[a-zA-Z]+\.)*[a-zA-Z][a-zA-Z-]{0,66})\.([a-zA-Z]{2,6}(?:\.[a-zA-Z]{2})?)$/;

                            if (emailRegex.test(email)) {
                              debouncedEmailCheck(email, (status: any) => {
                                if (status) {
                                  setCheckEmailStatus(true);
                                } else {
                                  setCheckEmailStatus(false);
                                }
                              }); // Now this runs for valid emails
                            }

                            handleNameChange(0, 'email', e);
                          }}
                          helperText={
                            errors['email'] ? errors['email']?.message : ''
                          }
                          disabled={isDisabled}
                          requiredField
                        />
                      </Grid>

                      <Grid item md={4} xs={12}>
                        <AutocompleteSelect
                          id="Department"
                          name={`departmentId`}
                          // disabled={isEdit || isEditCrew}
                          control={control}
                          labelText="Select Department"
                          placeHolderText="Select Department"
                          options={deptList || []}
                          error={
                            !!errors['departmentId'] && !!errors['departmentId']
                          }
                          // onChange={(e) =>
                          //   handleNameChange(0, 'departmentId', e.target.value)
                          // }
                          setValue={setValue}
                          onChange={(event, value) => {
                            setValue('departmentId', value);
                            setValue('roleName', null);
                          }}
                          helperText={
                            !!errors['departmentId']
                              ? errors['departmentId']?.message
                              : ''
                          }
                          defaultValue={''}
                          labelKey="deptName"
                          requiredField
                        />
                      </Grid>

                      <Grid item md={4} xs={12}>
                        <MUIAutoComplete
                          control={control}
                          name="roleName"
                          labelText="Select Job Title"
                          id="roleName"
                          keyName="roleName"
                          options={
                            selectedDepartment
                              ? [
                                  { roleName: 'Create New', isNew: true },
                                  ...roleList.map((i: any) => ({
                                    ...i,
                                    roleName: i?.roleName,
                                  })),
                                ]
                              : [{ roleName: 'Create New', isNew: true }]
                          }
                          setValue={setValue}
                          placeHolderText={
                            selectedDepartment
                              ? getValues('roleName')
                                ? ''
                                : 'Select Job Title'
                              : 'Select Department first'
                          }
                          addOptionText="Not in the List? Create New"
                          isScroll
                          fetchMoreOptions={fetchJobTitles}
                          hasMoreOptions={!!selectedDepartment}
                          disableSearch={!selectedDepartment}
                          disabled={!selectedDepartment}
                          onAdd={() => {
                            setIsJobTitleModalOpen(true);
                            setValue('roleName', '');
                          }}
                          fromAddCrewForm
                          requiredField
                          error={!!errors['roleName']}
                          helperText={
                            !!errors['roleName']
                              ? errors['roleName']?.message
                              : ''
                          }
                        />
                      </Grid>

                      <Grid item md={4} xs={12}>
                        <AutocompleteSelect
                          id="production"
                          labelText="Permissions"
                          placeHolderText="Select Permissions"
                          name="staticRoleId"
                          control={control}
                          // error={!!errors['productionId']}
                          options={options}
                          // disabled={isEdit || isEditCrew}
                          onChange={(e: any, value: any) => {
                            if (value) {
                              setValue('staticRoleId', value);
                              setValue('baseRole', value.label);
                              getPermissionRolesbyIdS(
                                value.value,
                                (data: any) => {
                                  // console.log('DDDDD =====>', tabs, data);
                                  setAllRoles(data);
                                  const names: any = [];
                                  tabs.forEach(element => {
                                    console.log(
                                      'data[element]',
                                      Object.keys(data[element]),
                                    );

                                    const key: any = Object.keys(
                                      data[element],
                                    )?.find(
                                      item =>
                                        item !== 'otherPermissions' &&
                                        item !== 'permissionVisibility',
                                    );

                                    // console.log('element =>>>', element);

                                    // console.log('key =>>>', key);

                                    names.push(key);
                                  });

                                  // console.log('names ===========>>', names);
                                  setKeyName(names);
                                },
                              );
                            }
                          }}
                          onInputChange={(event, value, reason) => {
                            if (reason === 'input' && value === '') {
                              setValue('staticRoleId', null);
                              setValue('baseRole', '');
                            }
                          }}
                          requiredField
                        />
                      </Grid>

                      {isEditCrew && !hideContactCheckbox && (
                        <Grid item md={12} xs={12}>
                          <div className="checkbox mt-12">
                            <input
                              type="checkbox"
                              id="isContact"
                              checked={isContactState}
                              onChange={e =>
                                setIsContactState(e.target.checked)
                              }
                            />
                            <label htmlFor="isContact">
                              Make this member a Contact member
                            </label>
                          </div>
                        </Grid>
                      )}

                      {/* <Grid item md={12} xs={12}>
                      <div className="checkbox mt-12">
                        <input type="checkbox" />
                        <label>
                          <span>Add User to access Risk Center</span>
                        </label>
                      </div>
                    </Grid> */}
                    </Grid>
                  </div>
                }
              />

              {
                <SectionContainer
                  heading="Access Details"
                  children={
                    <>
                      {getValues('staticRoleId') ? (
                        <div className="formContainer accessControl">
                          <Box sx={{ width: '100%' }} padding={0}>
                            <Box
                              sx={{ borderBottom: 0, borderColor: 'divider' }}
                              className="tabsContainer"
                            >
                              <Tabs
                                value={valueTab}
                                onChange={handleTabChange}
                                aria-label="basic tabs example"
                                variant="scrollable"
                                centered
                                scrollButtons={false}
                                allowScrollButtonsMobile
                              >
                                <Tab label="Production" {...a11yProps(0)} />
                                <Tab label="Episode" {...a11yProps(1)} />
                                <Tab label="Set" {...a11yProps(2)} />
                                <Tab label="Location" {...a11yProps(3)} />
                              </Tabs>
                            </Box>
                            <CustomTabPanel value={valueTab} index={0}>
                              <ProductionRoles
                                roles={allRoles?.productionPermissions}
                                name={keyName[0]}
                                visibility={allRoles?.documentVisibility}
                                roleDetails={allRoles}
                                handleChangeCall={handleChangeCall}
                                label={tabs[0]}
                                handleChangeVisiblity={handleChangeVisiblity}
                              />
                            </CustomTabPanel>
                            <CustomTabPanel value={valueTab} index={1}>
                              <ProductionRoles
                                roles={allRoles?.episodePermissions}
                                name={keyName[1]}
                                roleDetails={allRoles}
                                handleChangeCall={handleChangeCall}
                                label={tabs[1]}
                                handleChangeVisiblity={handleChangeVisiblity}
                              />
                            </CustomTabPanel>
                            <CustomTabPanel value={valueTab} index={2}>
                              <ProductionRoles
                                roles={allRoles?.setPermissions}
                                name={keyName[2]}
                                roleDetails={allRoles}
                                handleChangeCall={handleChangeCall}
                                label={tabs[2]}
                                handleChangeVisiblity={handleChangeVisiblity}
                              />
                            </CustomTabPanel>
                            <CustomTabPanel value={valueTab} index={3}>
                              <ProductionRoles
                                roles={allRoles?.locationPermissions}
                                name={keyName[3]}
                                roleDetails={allRoles}
                                handleChangeCall={handleChangeCall}
                                label={tabs[3]}
                                handleChangeVisiblity={handleChangeVisiblity}
                              />
                            </CustomTabPanel>

                            {/* <Grid container spacing={2} className="mb-12">
                          <Grid item xs={3}>
                            <div className="form-in left-icon">
                              <InputField
                          :      id="Approval"
                                label="Order Approval Amount"
                                name="Approval"
                                placeholder="Enter order approval amount"
                                error={false}
                                helperText={''}
                              />
                              <span className="icon-left">
                                <i className="dollar-sign-icon"></i>
                              </span>
                            </div>
                          </Grid>
                        </Grid> */}

                            <Grid container spacing={2} className="mb-12">
                              <Grid item xs={12} md={4}>
                                <InputField
                                  id="discount"
                                  name="orderLimit"
                                  label="Order Limit"
                                  placeholder="Enter Order Limit"
                                  type="text"
                                  maxLength={7}
                                  control={control}
                                  error={!!errors['orderLimit']}
                                  helperText={
                                    errors['orderLimit']?.message || ''
                                  }
                                  startAdornment={
                                    <InputAdornment position="start">
                                      $
                                    </InputAdornment>
                                  }
                                  inputProps={{
                                    inputMode: 'numeric',
                                    pattern: '[0-9]*',
                                  }}
                                  onChange={e => {
                                    // Remove all non-numeric characters
                                    const numericValue = e.target.value.replace(
                                      /[^0-9]/g,
                                      '',
                                    );

                                    // Update the input field value
                                    e.target.value = numericValue;

                                    // Update react-hook-form value
                                    control.setValue(
                                      'orderLimit',
                                      numericValue,
                                      {
                                        shouldValidate: true, // Trigger validation
                                        shouldDirty: true, // Mark field as dirty
                                      },
                                    );
                                  }}
                                  onKeyDown={e => {
                                    // Allow only numeric keys and essential navigation/editing keys
                                    const allowedKeys = [
                                      8, // Backspace
                                      9, // Tab
                                      27, // Escape
                                      13, // Enter
                                      46, // Delete
                                      37, // Left Arrow
                                      38, // Up Arrow
                                      39, // Right Arrow
                                      40, // Down Arrow
                                      35, // End
                                      36, // Home
                                    ];

                                    const isNumericKey =
                                      (e.keyCode >= 48 && e.keyCode <= 57) || // Number keys 0-9
                                      (e.keyCode >= 96 && e.keyCode <= 105); // Numpad keys 0-9

                                    const isAllowedKey = allowedKeys.includes(
                                      e.keyCode,
                                    );

                                    // Block Shift + number keys (which produce special characters like !@#$%^&*())
                                    if (
                                      e.shiftKey &&
                                      e.keyCode >= 48 &&
                                      e.keyCode <= 57
                                    ) {
                                      e.preventDefault();
                                      return;
                                    }

                                    // Prevent all keys except numbers and allowed navigation keys
                                    if (!isNumericKey && !isAllowedKey) {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                              </Grid>
                            </Grid>

                            <div className="formButtons end">
                              <CustomButton
                                onClick={handleOpenWarning}
                                size="large"
                                variant="outlined"
                                text="Cancel"
                                width="auto"
                                type="button"
                                id="cancel"
                                showIcon={false}
                              />

                              <CustomButton
                                size="large"
                                variant="contained"
                                text={
                                  isSubmitting
                                    ? 'Saving...'
                                    : isEdit
                                    ? 'Update'
                                    : 'Add'
                                }
                                width="auto"
                                type="submit"
                                id="drafted"
                                showIcon={false}
                                disabled={isSubmitting}
                                onClick={() => {
                                  console.log('Update button clicked!');
                                  console.log('Current form errors:', errors);
                                  console.log(
                                    'Current form values:',
                                    getValues(),
                                  );
                                }}
                              />
                            </div>
                          </Box>
                        </div>
                      ) : (
                        <NoData
                          heading="Please Select Permission."
                          // title="You have not added any contacts yet."
                          // buttonText="Add"
                        />
                      )}
                    </>
                  }
                />
              }
              <WarningDialog
                open={warningOpen}
                title={isCrew ? 'Cancel Crew Member?' : 'Cancel Contact?'}
                description={
                  isCrew
                    ? 'Are you sure you want to cancel the Crew Member?'
                    : 'Are you sure you want to cancel the Contact?'
                }
                type="warning"
                handleClose={() => setWarningOpen(false)}
                onClick={() => {
                  setWarningOpen(false);
                  navigate(-1);
                }}
                cancelBtnText="Cancel"
                confirmBtnText="Yes, Sure"
                showIcon={false}
              />
            </form>
          </div>
        )}
        <AddJobTitleModal
          open={isJobTitleModalOpen}
          onClose={() => {
            setValue('roleName', '');
            setIsJobTitleModalOpen(false);
          }}
          departmentIds={selectedDepartment}
          onSuccess={newJobTitle => {
            if (newJobTitle) {
              setValue('roleName', newJobTitle);
            }
            setIsJobTitleModalOpen(false);
            setIsCrewOpen(true);
          }}
        />
      </div>
    </>
  );
};

export default AddContactsProducts;
